<template>
    <div class="popup-lottery" v-if="popShow">
        <div class="popup-lottery-wrapper">
            <div
                class="popup-lottery-free"
                :class="[lang]"
                v-html="$t('popup.draw.free')"
                v-if="firstBattle"
            ></div>
            <div class="popup-lottery-bottom"></div>
            <div class="popup-lottery-panel" :class="[lang]"></div>
            <div
                class="popup-lottery-cls"
                @click="handlePopCls"
                v-show="!firstBattle && lotteryClsShow"
            ></div>
            <div class="popup-lottery-start" @click="startDraw"></div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

export default {
    name: 'popup-lottery',
    data() {
        return {
            lottery: null,
            clsShow: true
        };
    },
    computed: {
        popShow() {
            return this.$store.state.popup.lottery;
        },
        lang() {
            return this.$store.state.lang;
        },
        // 第一次对战
        firstBattle() {
            const userinfo = this.$store.state.userinfo;
            return userinfo && userinfo.get_gift_battle == 2;
        },
        lotteryClsShow() {
            return this.$store.state.lotteryClsShow;
        }
    },
    methods: {
        ...mapMutations(['PLAY_SOUND', 'STOP_SOUND']),
        ...mapActions(['drawReward', 'showComm']),
        handlePopCls() {
            this.$store.commit('HIDE_ALL_POPUP');
        },
        // 开始抽奖
        async startDraw() {
            this.PLAY_SOUND('button');
            this.$LOG.send_click_draw();
            if (this.$store.state.userinfo) {
                const score = this.$store.state.userinfo.score;
                if (score >= 1000 || this.firstBattle) {
                    const activeId = this.firstBattle
                        ? this.$store.state.activeIdFirst
                        : this.$store.state.activeId;
                    this.drawReward(activeId);
                } else {
                    this.showComm({
                        text: this.$t('popup.noScoreTips'),
                        size: 'big',
                        hasCls: true,
                        hasDownload: true
                    });
                }
            }
        }
    }
};
</script>

<style lang="less" scoped>
.popup-lottery {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 28px;
    display: flex;

    &-wrapper {
        width: 570px;
        height: 589px;
        margin: 160px auto 0;
        // margin: auto;
        // background: #fff;
        position: relative;
    }

    &-free {
        width: 442px;
        height: 150px;
        background: url(~@/assets/img/lottery_free.png) center/100% 100%
            no-repeat;
        position: absolute;
        top: -90px;
        left: 50%;
        margin-left: -221px;
        padding-top: 6px;
        box-sizing: border-box;
        text-align: center;
        color: #fff;
        font-size: 26px;
        font-weight: bold;
        line-height: 1.2;

        &.en {
            font-size: 18px;
        }

        &.ru {
            padding-top: 16px;
            font-size: 18px;
        }
    }

    &-bottom {
        width: 453px;
        height: 91px;
        position: absolute;
        bottom: 0;
        left: 50%;
        margin-left: -221px;
        background: url(~@/assets/img/lottery_bottom.png) center/100% 100%
            no-repeat;
    }

    &-panel {
        width: 559px;
        height: 563px;
        margin: 0 auto;
        position: relative;
        z-index: 1;

        &.zh {
            background: url(~@/assets/img/lottery_en_bg.png) center/100% 100%
                no-repeat;
        }

        &.en {
            background: url(~@/assets/img/lottery_en_bg.png) center/100% 100%
                no-repeat;
        }

        &.ru {
            background: url(~@/assets/img/lottery_ru_bg.png) center/100% 100%
                no-repeat;
        }
    }

    &-start {
        width: 154px;
        height: 235px;
        background: url(~@/assets/img/lottery_start_btn.png) center/100% 100%
            no-repeat;
        position: absolute;
        z-index: 1;
        top: 129px;
        left: 50%;
        margin-left: -76px;
    }

    &-cls {
        width: 69px;
        height: 133px;
        background: url(~@/assets/img/lottery_cls.png) center/100% 100%
            no-repeat;
        position: absolute;
        right: 0;
        top: 0;
        z-index: 1;
    }
}
</style>
